import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import { Hero } from '../../components/Hero';
import { Actions } from '../../flux';
import { DropDown } from '../../components/DropDown';
import { Fade } from 'react-reveal/';
import {  DelayLink } from '../../components';

//Dados
import PerfilOrganizacional from '../../static/json/SumarioPerfilOrganizacional.json';
import Estrategia from '../../static/json/Estrategia.json';
import EticaIntegridade from '../../static/json/EticaIntegridade.json';
import Governanca from '../../static/json/Governanca.json';
import EngajamentoStakeholders from '../../static/json/EngajamentoStakeholders.json';
import PraticasReporte from '../../static/json/PraticasReporte.json';
import DesempenhoEconomico from '../../static/json/DesempenhoEconomico.json';
import ImpactosEconomicosDiretos from '../../static/json/ImpactosEconomicosDiretos.json';
import Emprego from '../../static/json/Emprego.json';
import TreinamentoEducacao from '../../static/json/TreinamentoEducacao.json';
import DiversidadeIgualdadeOportunidades from '../../static/json/DiversidadeIgualdadeOportunidades.json';

//Imagens
import { images, texts } from '../../settings';

import './Sumario.scss';

class Sumario extends Component {
  constructor(props) {
    super(props)
    
    this.perfilOrganizacional = PerfilOrganizacional;
    this.estrategia = Estrategia;
    this.etica_e_integridade = EticaIntegridade;
    this.governanca = Governanca;
    this.engajamento_de_stakeholders = EngajamentoStakeholders;
    this.praticas_de_reporte = PraticasReporte;

    this.desempenho_economico = DesempenhoEconomico;
    this.impacto_economicos_indiretos = ImpactosEconomicosDiretos;
    this.emprego = Emprego;
    this.treinamento_e_educacao = TreinamentoEducacao;
    this.diversidade_e_igualdade_de_oportunidades = DiversidadeIgualdadeOportunidades;
  }
  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }
  async componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }
  render() {
    return (
      <div className="views views--sumario">
        <Helmet>
          <title>Sumário GRI - {texts.title}</title>
        </Helmet>
        {/* <Hero
          estilo="heroDefault"
          titulo="<span class='gri_text gri_text--fixed'><span class='hero__titulo-light'>Sumário </span>GRI <span class='gri_label'>GRI <b>102-55</b></span></span>"
          subtitulo="
            <p>Você deve ter reparado que várias páginas deste relatório contêm a indicação <strong>GRI</strong>. Ela se refere à Global Reporting Initiative, uma organização internacional que estimula as instituições a relatarem suas iniciativas de sustentabilidade, com base em aspectos econômicos, sociais e ambientais. Cada número ao lado da sigla GRI corresponde a uma diretriz específica, ou seja, um padrão definido para todas as empresas divulgarem suas informações.</p>
            <p>Usar essas referências dá mais transparência às nossas atividades e deixa mais fácil a comparação com os relatórios de outras companhias. Abaixo estão todos os indicadores que reportamos e em qual(is) página(s) eles estão - basta clicar sobre o texto para conferir.</p>
          "
          imagem={images.sumario.sumario_hero}
          background={images.bgs.bg_green}
        /> */}

        <div className="sumario-home page-gradient page-gradient--green bg-gray" ref="sumario-home">
          <section className="sumario-home-area governanca-header page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-5">
                  <Fade bottom>
                    <div className="page-header">
                      <h1 className="page-header__title gri_text gri_text--fixed">
                        <span class='hero__titulo-light'>Sumário </span>GRI
                        <span class='gri_label'>GRI <b>102-55</b></span>
                      </h1>
                      <p className="page-header__description">
                        Você deve ter reparado que várias páginas deste relatório contêm a indicação <strong>GRI</strong>. Ela se refere à Global Reporting Initiative, uma organização internacional que estimula as instituições a relatarem suas iniciativas de sustentabilidade, com base em aspectos econômicos, sociais e ambientais. Cada número ao lado da sigla GRI corresponde a uma diretriz específica, ou seja, um padrão definido para todas as empresas divulgarem suas informações.
                        <br /><br />
                        Usar essas referências dá mais transparência às nossas atividades e deixa mais fácil a comparação com os relatórios de outras companhias. Abaixo estão todos os indicadores que reportamos e em qual(is) página(s) eles estão - basta clicar sobre o texto para conferir.
                      </p>
                    </div>
                  </Fade>
                </div>

                <div className="col-7 col-image">
                  <img src={images.sumario.sumario_hero} class="pc_mobile" />

                  <img src={images.sumario.braco_homem} class="braco_homem img_desk" />
                  <img src={images.sumario.homem} class="homem img_desk" />
                  {/* <img src={images.sumario.lupa_mulher} class="lupa_mulher img_desk" /> */}
                  <img src={images.sumario.mulher} class="mulher img_desk" />
                  <img src={images.sumario.pc} class="pc img_desk" />
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="conteudo-topo">
          <div className="conteudo-interno">
            <h1 className="titulo-sumario">Divulgações gerais</h1>
            <DropDown
              titulo="Perfil organizacional"
              dados={this.perfilOrganizacional}
            />
            <DropDown
              titulo="Estratégia"
              dados={this.estrategia}
            />
            <DropDown
              titulo="Ética e integridade"
              dados={this.etica_e_integridade}
            />
            <DropDown
              titulo="Governança"
              dados={this.governanca}
            />
            <DropDown
              titulo="Engajamento de stakeholders"
              dados={this.engajamento_de_stakeholders}
            />
            <DropDown
              titulo="Práticas de reporte"
              dados={this.praticas_de_reporte}
            />
          </div>
          
          <div className="conteudo-interno conteudo-interno--second">
            <h1 className="titulo-sumario">Tópicos materiais</h1>
            <DropDown
              titulo="Desempenho econômico"
              dados={this.desempenho_economico}
              respostaGeral={'Nosso plano de previdência privada é administrado pelo Itaú Fundo Multipatrocinado e está estruturado na modalidade de contribuição variável (CNPB 1995-0007-11). De adesão voluntária, é oferecido a todos os funcionários, sendo que a contribuição da patrocinadora corresponde a 100% da contribuição efetuada pelo participante, em um percentual entre 4% e 7% da parcela do salário. Os funcionários podem contribuir com até 12% do salário ou fazer contribuições voluntárias, mas nesse caso não há contrapartida da empresa. A partir de 55 anos de idade e com o término do vínculo empregatício, o participante pode requerer o benefício de aposentadoria privada. No final de 2019, o plano contava com 285 participantes ativos e 31 aposentados.'}
            />
            <DropDown
              titulo="Impactos econômicos indiretos"
              dados={this.impacto_economicos_indiretos}
            />
            <DropDown
              titulo="Emprego"
              dados={this.emprego}
            />
            <DropDown
              titulo="Treinamento e educação"
              dados={this.treinamento_e_educacao}
            />
            <DropDown
              titulo="Diversidade e igualdade de oportunidades"
              dados={this.diversidade_e_igualdade_de_oportunidades}
            />
          </div>
        </div>

        <div className="container container--footer">
          <div className="row">
            <div className="col-12">
              
              <Fade>
                <div className="box-pill box-pill--blue box-pill--center">
                  <div className="box-pill__content box-pill__content--full">
                    <div className="row">
                      <div className="col col-8 col--text col--text--end">
                        <h4>Saiba mais sobre o relatório</h4>
                        <DelayLink to="/sobre-o-relatorio" className="button button--aylen button--white-to-blue button--border-medium button--size-m button--round-l button--text-thick">Veja mais</DelayLink>
                      </div>
                      <div className="col col-4">
                        <img src={images.sobre_relatorio.pessoa1} className="pessoa_destaque pessoa_destaque--bottom pessoa_destaque--right" />
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export { Sumario }